import React from 'react'
import { InputLabel, MenuItem, Select, FormHelperText } from '@material-ui/core'
import { SelectProps } from '@material-ui/core/Select'
import { StyledFormControl, StyledPlaceholder } from './styled'

export interface IStyledSelect extends SelectProps {
  label?: string
  children: any[]
  placeholder?: string
  helperText?: string
  id?: string
  value: any
  disabled?: boolean
  name?: string
  onChange: (e: any) => void
}

export const StyledSelect = ({
  label,
  children,
  placeholder,
  helperText = '',
  value,
  disabled = false,
  ...rest
}: IStyledSelect) => (
  <StyledFormControl fullWidth disabled={disabled}>
    {label &&
      (<InputLabel shrink htmlFor={rest.id} error={rest.error} disabled={disabled}>
        {label}
      </InputLabel>)}
    <Select
      value={value === null ? '' : value}
      disabled={disabled}
      {...rest}
      displayEmpty
    >
      {placeholder &&
        (<MenuItem value="" disabled>
          <StyledPlaceholder id="placeholder">{placeholder}</StyledPlaceholder>
        </MenuItem>)}
      {children.map((item, index) => (
        <MenuItem key={index} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
    {!!helperText && (
      <FormHelperText error={rest.error}>{helperText}</FormHelperText>
    )}
  </StyledFormControl>
)
